import { datadogRum } from '@datadog/browser-rum'
import clientLogger from './client-logger'

export function initDatadog({ applicationId, clientToken, userId }) {
  try {
    if (typeof window !== 'undefined') {
      datadogRum.init({
        applicationId,
        clientToken,
        site: 'us5.datadoghq.com',
        service: 'creditloanbldrnodeweb',
        env: process.env.NODE_ENV,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: 'mask-user-input',
        startSessionReplayRecordingManually: true,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
      })

      datadogRum.startSessionReplayRecording({ force: true })

      if (userId) {
        datadogRum.setUser({ id: userId })
      }
    }
  } catch (error) {
    const errorMessage = error?.message || ''
    clientLogger.error(`Error while initializing the datadog RUM: ${errorMessage}`)
  }
}
